<template>
  <article class="registration-steps">
    <h2 class=registration-steps__title>Passo 2</h2>

    <div class="registration-steps__wrapper">
      <p class="registration-steps__message">
        <big><strong>
        Escolha pelo menos 2 dias na semana para atender os pacientes do aplicativo Dr.Conecta
        </strong></big>
      </p>

      <ul class="drconecta-week">
        <li
          v-for="(value, $index) of weekdays"
          :key="$index"
          class="drconecta-week__day"
        >
          <label
            class="drconecta-week__label"
            :for="$index"
            :class="checkSelected($index)"
          >
            {{ value }}
          </label>

          <input
            type="checkbox"
            class="drconecta-week__checkbox"
            v-model="weekdaysSelected"
            :value="$index"
            :id="$index"
          />
        </li>
      </ul>

      <!-- <button @click="$router.replace({path: '1'})" class="btn">Voltar</button> -->
      <button :disabled="weekdaysSelected.length < 2" @click="next()" class="btn btn-primary">Avançar</button>
    </div>
  </article>
</template>

<script>

export default {
  props: ['formData'],
  data () {
    return {
      weekdays: {
        0: 'domingo',
        1: 'segunda',
        2: 'terça',
        3: 'quarta',
        4: 'quinta',
        5: 'sexta',
        6: 'sábado'
      },
      weekdaysSelected: []
    }
  },
  validations: {
    weekdaysSelected: {
      minLength: (v) => {
        return !(v.length < 2)
      }
    }
  },
  created () {
    this.formData.weekdaysSelected = []
  },
  mounted () {
    this.fn_HIDE_PROGRESS()
  },
  methods: {
    checkSelected (day) {
      if (this.weekdaysSelected.indexOf(day) > -1) {
        return 'selected drconecta-week__label--selected'
      }
    },
    next () {
      this.$v.$touch()
      if (this.$v.invalid) {
        return
      }
      this.weekdaysSelected.sort()
      let newArr = []
      for (let selected of this.weekdaysSelected) {
        newArr.push(this.weekdays[selected])
      }
      this.$emit('step-change', ['weekdaysSelected', newArr])
      this.$router.push({path: '/register/' + this.$route.params.id + '/doctor-office/agenda/new/2'})
    }
  }
}
</script>
